import { createSlice } from "@reduxjs/toolkit";
import { steps } from "../../AppStepperData";

const initialState ={
    stage : {},
    stepper: []
}

function modifyStepper(data, stepData) {
    const { step, nestedStep } = data;
    let updatedStepData = [...stepData];
    if(stepData?.length > 0) {
        if(stepData[step - 1]) {
            if(stepData[step - 1] < steps[step - 1].nestedSteps.length) {
                updatedStepData[step - 1] = nestedStep
            }
        } else {
            updatedStepData.push(nestedStep);
        }
    } else {
        updatedStepData.push(nestedStep);
    }
    return updatedStepData;
}

const stageSlice = createSlice({
    // name: 'cake',
    // initialState,
    // reducers:{
    //     ordered: (state) =>{
    //          state.numOfCake--
    //     },
    //     restocked: (state, action) =>{
    //         state.numOfCake += action.payload
    //     },
    // },

    name: "stage",
    initialState,
    reducers:{
        addStageData: (state, action) =>{
            state.stage = {...state.stage, ...action.payload}
        },
        updateStepper: (state, action) =>{
            state.stepper = action.payload?.setDirectly ? action.payload?.stepper : modifyStepper(action.payload, state.stepper)
        }
    },
})

export const { addStageData, updateStepper } = stageSlice.actions
export default stageSlice.reducer
